import React, { Component } from "react";
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import SaleService from './shop-components/sale-service';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import { withAppData } from "../app/withAppData";

class SaleServiceV1 extends Component {
    render() {
      const { serviceRegion, loading, lang, pageConfig } = this.props.appData;
      const serviceRegionConfig = pageConfig?.serviceRegion?.settings?.translations?.[lang] || {};
      const serviceRegionImg = pageConfig?.serviceRegion?.settings?.cover;  
  
      return (
        <div>
          <Navbar />
          <PageHeader
            lang={lang}
            Img={serviceRegionImg}
            headertitle={serviceRegionConfig.title || "Satış & Servis"}
            subheader={serviceRegionConfig.title || "Satış & Servis"}
          />
          <SaleService lang={lang} serviceRegionPageConfig={serviceRegionConfig} serviceRegion={serviceRegion} loading={loading} />
          <CallToActionV1 />
          <Footer />
        </div>
      );
    }
  }
  
  export default withAppData(SaleServiceV1);